"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/Persona/index"), exports);
//# sourceMappingURL=Persona.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/Persona.js
// module id = ../node_modules/office-ui-fabric-react/lib/Persona.js
// module chunks = 1